export default __webpack_public_path__ + "static/media/closegray.f126b8fb.svg";